import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { useTranslation } from 'next-i18next';
import { cn } from '@/utils';

/**
 * QuizEssayAnswer - 서술형(essay) 문제 전용 답안 UI
 * 향후 서술형 관련 UI 확장 시 이 파일에 추가
 */

const AnswerMarker = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => <div className={cn('flex size-[30px] flex-shrink-0 items-center justify-center rounded-full border-[3px] border-white shadow-xs self-start', className)} {...props} data-sentry-component="AnswerMarker" data-sentry-source-file="QuizEssayAnswer.tsx">
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" className="translate-x-[1px]" viewBox="0 0 9 13" fill="none" data-sentry-element="svg" data-sentry-source-file="QuizEssayAnswer.tsx">
      <path d="M1.25 1.25006L6.97344 6.0196C7.11737 6.13953 7.11737 6.36059 6.97344 6.48053L1.25 11.2501" stroke="white" strokeWidth="2.5" strokeLinecap="round" data-sentry-element="path" data-sentry-source-file="QuizEssayAnswer.tsx" />
    </svg>
  </div>;
const ItemRoot = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>(({
  children,
  className,
  ...rest
}, ref) => <div ref={ref} className={cn('flex w-full items-center gap-sm', className)} {...rest}>
      {children}
    </div>);
ItemRoot.displayName = 'QuizEssayAnswerItemRoot';
const ItemContent = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>(({
  children,
  className,
  ...rest
}, ref) => <div ref={ref} className={cn('w-full', className)} {...rest}>
      <span className="w-full text-heading-sm-bold">{children}</span>
    </div>);
ItemContent.displayName = 'QuizEssayAnswerItemContent';
const Placeholder = () => {
  const {
    t
  } = useTranslation(['common']);
  return <ItemRoot data-sentry-element="ItemRoot" data-sentry-component="Placeholder" data-sentry-source-file="QuizEssayAnswer.tsx">
      <AnswerMarker className="bg-gray-400" data-sentry-element="AnswerMarker" data-sentry-source-file="QuizEssayAnswer.tsx" />
      <ItemContent className="text-disabled" data-sentry-element="ItemContent" data-sentry-source-file="QuizEssayAnswer.tsx">
        {t('common:quizItem.essayPlaceholder')}
      </ItemContent>
    </ItemRoot>;
};
export const QuizEssayAnswer = {
  ItemRoot,
  AnswerMarker,
  ItemContent,
  Placeholder
};